import ClassDisplaySimple from "./ClassDisplaySimple";

export default ClassDisplaySimple;
export { ClassDisplaySimple };
